import React, { useState, useEffect } from "react";
import "./cycleDistributors.scss";
import { InputText } from "primereact/inputtext";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { getDeservantsForCycle } from "../../../apis/DeservantApi";
import { MultiSelect } from "primereact/multiselect";
import { addCycleDistributor } from "../../../apis/CycleDistributorApi";
import { formatMobile } from "../../../utils/formatters";

const CycleDistributors = (props) => {
  const [allDeservants, setAllDeservants] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [selectedDeservant, setSelectedDeservant] = useState([]);
  const [loading, setLoading] = useState(true);
  const [distributorOptions, setDistributorOptions] = useState([]);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "referredBy.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "distributor.userId.name": {
      value: null,
      matchMode: FilterMatchMode.IN,
    },
    "userId.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "userId.cnic": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    "userId.mobile": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    familyMember: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const fetchDeservants = () => {
    getDeservantsForCycle(props.id).then((res) => {
      setAllDeservants(res.data);
      if (res.data && res.data.length > 0) {
        const unique = [];
        const map = new Map();
        for (const item of res.data) {
          if (item.distributor && !map.has(item.distributor.id)) {
            map.set(item.distributor.id, true);
            unique.push(item.distributor);
          }
        }
        const sortedOptions = unique
          .filter((dist) => dist && dist.userId && dist.userId.name)
          .sort((a, b) => a.userId.name.localeCompare(b.userId.name));
        setDistributorOptions(sortedOptions);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchDeservants();
  }, [props.id]);

  useEffect(() => {}, [selectedDeservant]);

  const { reset } = useForm();

  const submitData = () => {
    var allIds = [];
    selectedDeservant.forEach((deservant) => {
      var obj = {
        deservantId: deservant.id,
        distributorId: deservant.distributor.id,
        cycleId: props.id,
      };
      allIds.push(obj);
    });
    addCycleDistributor(allIds).then((res) => {
      if (res.status === 200) {
        props.currentCycleDeservants();
        reset();
        props.hide();
      }
    });
  };

  const renderHeader = () => {
    if (!allDeservants || allDeservants.length === 0) {
      return (
        <div className="table-header tab-adjuster-cycle-distributor">
          <h5 className="m-0">Cycle Deservants</h5>
        </div>
      );
    }
    return (
      <div className="table-header tab-adjuster-cycle-distributor">
        <h5 className="m-0">Cycle Deservants</h5>
        <span
          className="p-input-icon-left"
          style={{ width: "100%", maxWidth: "200px" }}
        >
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
            style={{ width: "100%" }}
          />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  const distributorFilterTemplate = (options) => {
    return (
      <MultiSelect
        value={options.value}
        options={distributorOptions}
        onChange={(e) => options.filterApplyCallback(e.value)}
        optionLabel="userId.name"
        optionValue="userId.name"
        placeholder="Select Any"
        className="p-column-filter"
        maxSelectedLabels={1}
        filter
        scrollHeight="250px"
        style={{ width: "100%", fontSize: "1rem" }}
      />
    );
  };

  return (
    <div className="layout-main" style={{ width: '100%' }}>
      <div className="datatable-doc-demo" style={{ width: '100%' }}>
        <div className="card" style={{ width: '100%' }}>
          <DataTable
            value={allDeservants}
            selection={selectedDeservant}
            onSelectionChange={(e) => setSelectedDeservant(e.value)}
            filters={filters}
            onFilter={(e) => setFilters(e.filters)}
            filterDisplay="row"
            responsiveLayout="scroll"
            globalFilterFields={[
              "distributor.userId.name",
              "userId.name",
              "userId.cnic",
              "userId.mobile",
            ]}
            emptyMessage="No Cycle Deservants found."
            dataKey="id"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Deservants"
            header={header}
            loading={loading}
            className="table-sel"
            style={{ width: '100%', minWidth: '600px' }}
            tableStyle={{ width: '100%' }}
          >
            <Column
              key="referredBy.id"
              selectionMode="multiple"
              headerStyle={{ width: "3em" }}
            ></Column>

            <Column
              field="userId.name"
              header="Deservants"
              body={(record) => {
                return record.userId.name;
              }}
              sortable
              filter
              showFilterMenu={false}
              filterPlaceholder="Search"
              style={{ width: "180px" }}
            />

            <Column
              key="distributor.id"
              field="distributor.userId.name"
              header="Distributor"
              body={(record) => {
                return record.distributor.userId.name;
              }}
              sortable
              filter
              showFilterMenu={false}
              filterElement={distributorFilterTemplate}
              filterPlaceholder="Filter"
              style={{ width: "150px" }}
            />

            {/* <Column
              key="refferedBy.id"
              field="refferedBy.name"
              header="Reffered By"
              body={(record) => {
                if (record.referredBy) {
                  return record.referredBy.name;
                } else {
                  return "N/A";
                }
              }}
              sortable
              filterPlaceholder="Search by userId.name"
              style={{ width: "7rem" }}
            /> */}

            <Column
              field="userId.cnic"
              header="Cnic"
              body={(record) => {
                return record.userId.cnic;
              }}
              sortable
              filter
              showFilterMenu={false}
              filterPlaceholder="Search"
              style={{ width: "80px" }}
            />

            <Column
              field="userId.mobile"
              header="Mobile"
              body={(record) => {
                return formatMobile(record.userId.mobile);
              }}
              sortable
              filter
              showFilterMenu={false}
              filterPlaceholder="Search"
              style={{ width: "80px" }}
            />

            <Column header="" style={{ width: "auto" }} />

            {/* <Column
              field="familyMember"
              header="Family Members"
              body={(record) => {
                return record.familyMember;
              }}
              sortable
              filterPlaceholder="Search by familyMember"
              style={{ minWidth: "10rem" }}
            /> */}
          </DataTable>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
          <Button label="Submit" className="submit-btn" onClick={submitData} />
        </div>
      </div>
    </div>
  );
};

export default CycleDistributors;
